import { BaseContract, ethers } from 'ethers';
import { useMemo } from 'react';
import { isNativeCurrency } from '@orionprotocol/common';

import { useAddressProvider } from './useAddressProvider';

export function useContract<T extends BaseContract>(
  address: string | undefined,
  providerOrSigner: ethers.Provider | ethers.Signer | undefined,
  factory: {
    connect: (address: string, provider: ethers.Provider | ethers.Signer) => T;
  },
  updateIndex?: number,
): T | undefined {
  const providerAndAddress = useAddressProvider(address, providerOrSigner);

  const contract = useMemo(() => {
    const { address: currentAddress, providerOrSigner: currentProvider } =
      providerAndAddress;

    if (
      (updateIndex === undefined || updateIndex >= 0) &&
      currentAddress !== undefined &&
      currentProvider !== undefined &&
      !isNativeCurrency(currentAddress)
    ) {
      return factory.connect(currentAddress, currentProvider);
    }

    return undefined;
  }, [providerAndAddress, factory, updateIndex]);

  return contract;
}
